import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.state';
import { selectPermissions } from '@store/selectors/permission.selectors';
import { selectEncryptedTenantKey } from '@store/selectors/tenant.selectors';
import { PermissionService } from '@lib/services/permission.service';
import { combineLatest, map, filter, take } from 'rxjs';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const store = inject(Store<AppState>);
    const permissionService = inject(PermissionService);
    const requiredPermissions: string[] = route?.data?.['permission'] || [];

    return combineLatest([
        store.select(selectEncryptedTenantKey),
        store.select(selectPermissions),
    ]).pipe(
        filter(([_, permissions]) => permissions.length > 0), // wait for permission store to be populated
        take(1),
        map(([tenantKey, allPermissions]) => {
            // Case: Special handling for tenant0_api
            if (tenantKey === 'tenant0_api') {
                let visibleTabs: string[] = [];

                if (permissionService.isAdministrator()) {
                    visibleTabs = ['b:customer', 'b:callcenter', 'b:customer:cards', 'b:accessmgmt'];
                } else {
                    visibleTabs = ['b:customer', 'b:customer:cards', 'b:callcenter'];
                }

                if (requiredPermissions.length === 0) return false;

                return visibleTabs.some(tab =>
                    requiredPermissions.some(p => p.startsWith(tab))
                );
            }

            // Case: Regular permission match
            if (requiredPermissions.length === 0) return true;

            return requiredPermissions.some(p => allPermissions.includes(p));
        })
    );
};